import * as React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Popover,
  Button,
  Tooltip,
  IconButton,
  TextField,
  Grid,
  Pagination,
  Stack,
  Backdrop,
  CircularProgress,
  ListItem,
  ListItemText,
  ListItemButton,
  List,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import { InputAdornment } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, useEffect, useContext } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { PAGE_SIZE } from "../../Services/common/const";
import Title from "../../Components/Title";
import { PreferencesContext } from "../../PreferencesContext";
import { AlertType } from "../../shared/Modal/AlertType";
import MissingConsumer from "../../Components/MissingConsumer";
import { EncryptDecryptService } from "../../Services/common/EncryptionService";
import { styled, alpha, useTheme } from "@mui/material/styles";
import Menu, { MenuProps } from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import DownloadIcon from "@mui/icons-material/Download";
import { KeyboardArrowDownSharp } from "@mui/icons-material";
import SplashComponent from "../../Navigation/splash";
import { ImportData } from "../../Components/ImportData";
import { ImportCategory } from "../../Services/ImportService";
import { DownloadSampleFies } from "../../Services/DownloadServices";
import { ExportFilesFunction, numberFormat, useQuery } from "../../shared/CommonFuctions";
import { GetExpenseItemReport } from "../../Services/ReportService";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import ShortcutButton from "../../Components/ShortcutButton";
import { DeletePartyType, GetPartyTypeList } from "../../Services/PartyTypeService";
import {
  ListPaginationOrContent,
  TableRowsSkeleton,
} from "../../Components/DashboardSkeleton/DashboardSkeleton";
import { useListLoading } from "../../Components/DashboardSkeleton/useListLoading";

interface Data {
  buyerSupplierPartyId: number;
  code: string;
  Name: string;
  none: string;
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

type Order = "asc" | "desc" | "";

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(
  array: readonly T[] | null | undefined,
  comparator: (a: T, b: T) => number
): T[] {
  const safeArray = array ?? [];

  return [...safeArray].sort((a, b) => comparator(a, b));
}
interface EnhancedTableProps {
  numSelected: number;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
}

const PartyType: any = {
  partyTypeCollection: [],
};
const edService = new EncryptDecryptService();

const parameters: any = {
  pageIndex: 1,
  pageSize: PAGE_SIZE,
  sortColumn: "",
  sortDirection: "",
  searchValue: "",
};
export default function PartyTypeList() {
  const PartyTypeData = {
    title: "Add Party Type",
    button: "Save",
    buyerSupplierPartyId: 0,
    isAddPopUp: false,
  };

  const handleAddPartyType = (e: any) => {
    let encPartyTypeId: any = edService.encrypt(0);
    e.preventDefault();
    navigate(
      {
        pathname: "/party-type-save",
        search: `?q=${encodeURIComponent(encPartyTypeId)}&t=` + pItemTypeName,
      },
      {
        state,
      }
    );
  };
  const handleOpenMore = (
    event: React.MouseEvent<HTMLButtonElement>,
    item: any
  ) => {
    setAnchorEl3(event.currentTarget);
    setBuyerSupplierPartyId(item);
  };

  const handleCloseMore = () => {
    setAnchorEl3(null);
  };

  const theme = useTheme();
  let urlParams = useQuery();
  let pItemTypeName = urlParams.get("t");

  const mobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [buyerSupplierPartyId, setBuyerSupplierPartyId] = useState(null);
  const matches = useMediaQuery("(max-width:599px)");
  const mediumDevice = useMediaQuery("(max-width:899px)");
  const matchesformobile = useMediaQuery("(max-width:375px)");
  const [state, setState] = useState(PartyTypeData);
  const [param, setParam] = useState(parameters);
  const [anchorEl, setAnchorEl3] = useState<HTMLButtonElement | null>(null);
  const [selected, setSelected] = useState<readonly number[]>(
    PartyType.partyTypeCollection
  );
  const open = Boolean(anchorEl);
  const [totalCount, setTotalCount] = useState(0);
  const [pageStartIndex, setPageStartIndex] = useState(1);
  const [pageEndIndex, setPageEndIndex] = useState(1);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [value, setValue] = useState("");
  const [openDeleteModal, setopenDeleteModal] = React.useState(false);
  const [order, setOrder] = useState<Order>("");
  const [orderBy, setOrderBy] = useState<keyof Data>("none");
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE);
  const [resultData, setResultData] = useState<any>([]);
  const [page_Index, setPage_Index] = useState(1);
  const [counData, setCounData] = useState(0);
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  const [isLoading, setLoading] = useState(false);
  const { isListLoading, runListLoad } = useListLoading(true);
  const [isAllowAdd, setAllowAdd] = useState(true);
  const [Curr_page, setCurrPage] = useState(1);
  const [showLogo, setShowLogo] = useState("");
  const [catchError, setCatchError] = React.useState(null);
  const [logoselectedFile, setLogoSelectedFile] = useState<any>();
  const isSelected = (id: number) => selected.indexOf(id) !== -1;
  const [isLoadingForImport, setIsLoadingForImport] = React.useState(false);
  const [isOpenImport, setIsOpenImport] = React.useState(false);

  const handleCloseImport = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    else if (reason && reason === "close") {
      setIsOpenImport(false);
    } else {
      return;
    }
  };

  function EnhancedTableHead(props: EnhancedTableProps) {

    return (

      <TableHead className="table-header-color">
        <TableRow>
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              //width: "100%",
            }}
            align="left">
            {"Code"}
          </TableCell>
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              // width: "100%",
            }}
            align="left">
            {"Name"}
          </TableCell>
          <TableCell sx={{ width: "5%" }}></TableCell>
        </TableRow>
      </TableHead>
    );
  }

  const handleOpenImport = () => {
    setIsOpenImport(true);
  };

  const handleOpenDaletePartytypeModal = () => {
    setopenDeleteModal(true);
  };

  const handleCloseDeletePartytypeModal = () => {
    setopenDeleteModal(false);
    setAnchorEl3(null);
  };

  const handleCheckSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = resultData.map((n: any) => n.buyerSupplierPartyId);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  // Pagination
  const handleChangePageNew = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    if (Curr_page !== value) {
      setCurrPage(value);
      setPage_Index(value);
      setParam({ ...param, pageIndex: value });
      fetchPartyTypeList();
    }
  };
  //  Searching
  function searchValue(val: any) {
    if (val === "") {
      setValue("");
    }
    setPage_Index(1);
    setParam({ ...param, searchValue: val.toString(), pageIndex: 1 });
  }
  let navigate = useNavigate();

  async function fetchPartyTypeList() {
    await runListLoad(async () => {
      try {
        if (
          userContext != null &&
          userContext.consumerId != null &&
          userContext.consumerId > 0
        ) {
          setAllowAdd(true);
        } else {
          setAllowAdd(false);
        }
        let params = new URLSearchParams();
        params.append("consumerId", userContext.consumerId.toString());
        params.append("firmId", userContext.firmId.toString());
        params.append("branchId", userContext.branchId.toString());
        params.append("pageIndex", page_Index.toString());
        params.append("pageSize", param.pageSize);
        params.append("sortColumn", param.sortColumn);
        params.append("sortDirection", param.sortDirection);
        params.append("searchValue", param.searchValue);
        params.append("financialYear", userContext.currentFinancialYear);
        params.append("partyTypeCode", pItemTypeName === "buyer" ? "BUYER" : "SUPPLIER");
        params.append("mode", "");
        const result: any = await GetPartyTypeList(params);
        if (result && result.data.data) {
          let resultColl = result.data.data?.partyTypeCollection;
          let dataCount = result.data.data.totalCount;
          let showDataCount = Math.ceil(dataCount / PAGE_SIZE);
          setResultData(resultColl);
          setCounData(showDataCount);
          let startIndex = (page_Index - 1) * param.pageSize + 1;
          let endIndex =
            (page_Index - 1) * param.pageSize +
            (result?.data?.data?.partyTypeCollection
              ? result?.data?.data?.partyTypeCollection?.length
              : 0);
          setPageStartIndex(startIndex);
          setPageEndIndex(endIndex);
          setTotalCount(dataCount);
        } else {
          console.log("Error");
        }
      } catch (e: any) {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage:
            typeof e === "string" ? (e as string) : (e?.message as string),
          alertType: AlertType.Error,
        });
      }
    });
  }

  async function handleDeletePartyType(buyerSupplierPartyId: any) {
    try {
      let DeleteData = {
        ids: buyerSupplierPartyId.toString(),
        consumerId: userContext.consumerId,
        firmId: userContext.firmId,
        branchId: userContext.branchId,
        partyTypeCode: pItemTypeName === "buyer" ? "BUYER" : "SUPPLIER",
        isDeleted: true,
        dataManagedBy: userContext.userId,
      };
      const result: any = await DeletePartyType(DeleteData);
      if (result) {
        fetchPartyTypeList();
        setAnchorEl3(null);
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: result.message,
          alertType: AlertType.Success,
        });
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: result.message,
          alertType: AlertType.Error,
        });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
    setopenDeleteModal(false);
  }

  async function handleEditPartyType(buyerSupplierPartyId: any) {
    try {
      let encPartyTypeId: any = edService.encrypt(buyerSupplierPartyId);
      navigate(
        {
          pathname: "/party-type-save",
          search: `?q=${encodeURIComponent(encPartyTypeId)}&t=` + pItemTypeName,
        },
        {
          state: {
            button: "Update",
            buyerSupplierPartyId: buyerSupplierPartyId,
            isAddPopUp: "false",
          },
        }
      );
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  useEffect(() => {
    fetchPartyTypeList();
    let e: any = document.getElementById("root");
    e.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  }, [param, isOpenImport, pItemTypeName]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "F2") {
        event.stopImmediatePropagation();
        handleAddPartyType(event as any);
      } else if (event.key === "Escape") {
        event.stopImmediatePropagation();
        navigate("/dashboard");
      }
    };

    window.addEventListener("keydown", handleKeyDown, { capture: true });
    return () => {
      window.removeEventListener("keydown", handleKeyDown, { capture: true });
    };
  }, [navigate]);

  // report export start....
  const StyledMenu = styled((props: MenuProps) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      {...props}
    />
  ))(({ theme }) => ({
    "& .MuiPaper-root": {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 50,
      color:
        theme.palette.mode === "light"
          ? "rgb(55, 65, 81)"
          : theme.palette.grey[300],
      boxShadow:
        "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
      "& .MuiMenu-list": {
        padding: "4px 0",
      },
      "& .MuiMenuItem-root": {
        "& .MuiSvgIcon-root": {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        "&:active": {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity
          ),
        },
      },
    },
  }));

  const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);
  const openExportType = Boolean(anchorEl2);
  const handleClickExportType = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleCloseExportType = () => {
    setAnchorEl2(null);
  };
  
  useEffect(() => {
    setCatchError(null);
  }, [logoselectedFile]);
  const saveLogoFileSelected = (e) => {
    setShowLogo(e[0]);
    setLogoSelectedFile(e[0]);
  };
 
  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          backgroundColor: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}>
        <SplashComponent />
      </Backdrop>
      <Title pageTitle="Expense Item" />
      <Box
        className="boxContainer"
        sx={{
          "& > :not(style)": {
            width: "100%",
          },
        }}>
        {userContext.consumerId > 0 ? (
          <Grid>
            <Grid
              className="title-button-responsive"
              item
              xs={6}
              md={3}
              sx={{
                display: "flex !important",
                justifyContent: "space-between",
                alignItems: "center",
              }}>
              <h4 className="page-title">{pItemTypeName === "buyer" ? "Buyer" : "Supplier"} Party Type</h4>
              <Grid
                item
                xs={6}
                md={3}
                marginRight={0}
                gap={2}
                display={"flex"}
                textAlign="end"
                paddingTop="0px">
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleAddPartyType}
                  size="medium">
                  <ShortcutButton label="F2" variant="dark" />
                  Add
                </Button>
                {!matchesformobile && (
                  <Button
                    variant="outlined"
                    onClick={() => navigate("/dashboard")}
                    size="medium">
                    <ShortcutButton label="ESC" />
                    Back
                  </Button>
                )}
              </Grid>
            </Grid>
            {matchesformobile && (
              <Grid
                item
                xs={6}
                md={3}
                gap={2}
                display={"flex-end"}
                mt={1}
                marginRight={0}
                textAlign="end"
                paddingTop="0px"
              >
                <Button
                  variant="outlined"
                  onClick={() => navigate("/dashboard")}
                  size="medium">
                  <ShortcutButton label="ESC" />
                  Back
                </Button>
              </Grid>
            )
            }
            <Grid className="paper top-space">
              <Paper elevation={4} className="paper-container">
                <Grid container rowGap={1} className="search-space">
                  <Grid item xs={12} sm={6} md={8} lg={8} xl={8}>
                    {matches ? (
                      <TextField
                        autoFocus
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            searchValue(value);
                          }
                        }}
                        placeholder="Search..."
                        type="text"
                        variant="outlined"
                        size="small"
                        fullWidth
                        onChange={(e) => setValue(e.target.value)}
                        value={value}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <IconButton onClick={() => searchValue("")}>
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),

                          endAdornment: value && (
                            <IconButton
                              aria-label=""
                              onClick={() => searchValue("")}>
                              <ClearIcon />
                            </IconButton>
                          ),
                        }}
                      />
                    ) : (
                      <TextField
                        autoFocus
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            searchValue(value);
                          }
                        }}
                        placeholder="Search..."
                        type="text"
                        variant="outlined"
                        size="small"
                        onChange={(e) => setValue(e.target.value)}
                        value={value}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <IconButton onClick={() => searchValue(value)}>
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),

                          endAdornment: value && (
                            <IconButton
                              aria-label=""
                              onClick={() => searchValue("")}>
                              <ClearIcon />
                            </IconButton>
                          ),
                        }}
                      />
                    )}
                  </Grid>
                </Grid>
                <TableContainer>
                  <Table
                    aria-labelledby="tableTitle"
                    size={dense ? "small" : "medium"}>
                    <EnhancedTableHead
                      numSelected={selected.length}
                      order={order}
                      orderBy={orderBy}
                      onSelectAllClick={handleCheckSelectAll}
                      rowCount={totalCount}
                    />
                    <TableBody>
                      {isListLoading ? (
                        <TableRowsSkeleton rows={8} />
                      ) : (
                        <>
                      {

                        resultData && resultData?.map((item: any, index: any) => {
                          return (
                            <TableRow hover key={item.buyerSupplierPartyId}>
                              <TableCell
                                onClick={() =>
                                  mediumDevice
                                    ? handleEditPartyType(item.buyerSupplierPartyId)
                                    : null
                                }
                                sx={{
                                  display: {
                                    xs: "table-cell",
                                    sm: "table-cell",
                                    md: "table-cell",
                                    lg: "table-cell",
                                  },
                                }}
                                align="left">
                                <Button
                                  disableRipple
                                  color="inherit"
                                  onClick={() =>
                                    handleEditPartyType(item.buyerSupplierPartyId)
                                  }
                                  className="manuButton-link"
                                  style={{ backgroundColor: "transparent" }}>
                                  <span className="text-link">
                                    {item?.code}
                                  </span>
                                </Button>
                              </TableCell>
                              <TableCell
                                sx={{
                                  display: {
                                    xs: "table-cell",
                                    sm: "table-cell",
                                    md: "table-cell",
                                    lg: "table-cell",
                                  },
                                }}
                                align="left"
                              >
                                {item.name}
                              </TableCell>
                              <TableCell
                                sx={{
                                  display: {
                                    xs: "table-cell",
                                    sm: "table-cell",
                                    md: "table-cell",
                                    lg: "table-cell",
                                  },
                                }}
                                align="center"
                                height={55}
                              >
                                {item.consumerId > 0 ? (
                                  <Tooltip title="More" placement="top">
                                    <IconButton
                                      onClick={(e: any) =>
                                        handleOpenMore(e, item.buyerSupplierPartyId)
                                      }
                                    >
                                      <MoreVertIcon />
                                    </IconButton>
                                  </Tooltip>
                                ) : (
                                  <></>
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        })}

                      {totalCount === 0 ? (
                        <TableRow hover tabIndex={-1} key={"0"}>
                          <TableCell colSpan={6} align="center">
                            No record(s) found
                          </TableCell>
                        </TableRow>
                      ) : (
                        <></>
                      )}
                        </>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <ListPaginationOrContent
                  loading={isListLoading}
                  hasRows={totalCount > 0}
                >
                  <Grid
                    container
                    paddingTop={1}
                    alignItems={"center"}
                    justifyContent={"center"}>
                    <Grid item xs={12} sm={6} className="pagination-label">
                      {pageStartIndex} - {pageEndIndex} of {totalCount}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Stack
                        component="div"
                        alignItems={mobileScreen ? " center" : "end"}
                        justifyContent={"center"}>
                        <Pagination
                          color="primary"
                          count={counData}
                          page={page_Index}
                          onChange={handleChangePageNew}
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </ListPaginationOrContent>
              </Paper>
            </Grid>
          </Grid>
        ) : (
          <MissingConsumer consumerId={userContext.consumerId} />
        )}
      </Box>
      {/* Action popover - starts */}
      <Popover
        elevation={1}
        open={open}
        anchorEl={anchorEl}
        onClose={handleCloseMore}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}>
        <List>
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => handleEditPartyType(buyerSupplierPartyId)}>
              <ListItemText primary="Edit" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              className="delete-container"
              onClick={handleOpenDaletePartytypeModal}>
              Delete
            </ListItemButton>
          </ListItem>
        </List>
      </Popover>
      <Dialog
        open={openDeleteModal}
        onClose={handleCloseDeletePartytypeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this {pItemTypeName === "buyer" ? "Buyer" : "Supplier"} Party Type?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleDeletePartyType(buyerSupplierPartyId)}
            className="button-delete">
            Yes
          </Button>
          <Button onClick={handleCloseDeletePartytypeModal} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}